import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MeasureReference } from 'src/app/domain/GS/measure-reference';
import { MasterDataService } from 'src/app/services/GS/master-data.service';
import { MeasureService } from 'src/app/services/measure.service';
import { NotificationManager } from '../notification-manager';
import { EStrategyType } from 'src/app/domain/GS/strategy-type';
import { MeasureReferenceType } from 'src/app/domain/enums/measure-reference-type';

@Component({
    selector: 'change-letter-box',
    templateUrl: 'change-letter-box.html',
    styleUrls: ['./change-letter-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeLetterDialog implements OnInit {

    private interventionCode: string;
    private samplingId: number;
    private isForProcess: boolean;
    private strategyType: EStrategyType;
    public MeasureReferenceList: MeasureReference[] = [];
    public SelectedMeasureRef!: MeasureReference;

    constructor(
        private snackbar: MatSnackBar,
        private masterDataService: MasterDataService,
        private measureService: MeasureService,
        public dialogRef: MatDialogRef<ChangeLetterDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        this.interventionCode = data.interventionCode;
        this.strategyType = data.strategyType;
        this.samplingId = data.samplingId;
        this.isForProcess = data.isForProcess;
    }

    ngOnInit() {
        this.masterDataService.getAllMeasureReferences().subscribe(x => {
            this.MeasureReferenceList = x.filter(x => this.strategyType === EStrategyType.FDX ?
                x.Type === MeasureReferenceType.FDX || x.Type === MeasureReferenceType.horsFDX :
                x.Type === MeasureReferenceType.Gax || x.Type === MeasureReferenceType.None)

            if (this.isForProcess) {
                this.MeasureReferenceList = this.MeasureReferenceList.filter(x => ['SEPTP1', 'SEPTP2', 'CNEPO', 'SEDFP', 'SPRMPC', 'CNEPE', 'CNEPV', 'AC', 'I', 'Je', 'Jv', 'K'].includes(x.Code));
            } else {
                this.MeasureReferenceList = this.MeasureReferenceList.filter(x => !['I', 'Je', 'Jv', 'K', 'SEPTP1', 'SEPTP2', 'CNEPO', 'SEDFP', 'SPRMPC', 'CNEPE', 'CNEPV', 'AC'].includes(x.Code)).filter(y => !['HGMesureEau', 'HGMesureLingette', 'HGMesureMassif', 'HFMesureAdductionAir', 'HFMesureEau', 'HFMesureLingette', 'HFMesureMassif', 'HFMesureAdductionAir'].includes(y.Code));
            }
        })
    }

    onCancel() {
        this.dialogRef.close();
    }

    finish() {

        this.measureService.changeLetterForOfASampling(this.interventionCode, this.samplingId, this.SelectedMeasureRef.Code).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Mesure modifiée', this.snackbar);
                this.dialogRef.close(x);
            }
        })
    }
}
